export const PLAYLIST_USERS_LIST_SCREEN = 'PlaylistUsersList';
export const PLAYLIST_ATTRIBUTES_SCREEN = 'PlaylistAttributes';

// Screen names for pageview events
export const STATS_OVERVIEW_SCREEN = 'StatsOverview';
